export const SOCKET_KEYS = {
  WORKSPACE: "workspaces",
  NOTIFICATION: "notification",
  XERO_CONNECTION_STATUS: "xero-connection-status",
  ROSTER_DAY_SHEET: "roster-day-sheet",
  ROSTER_SUBCONTRACTOR: "roster-subcontractor",
  ROSTER_FLEETS: "roster-fleets",
  ROSTER_FLEET_TASKS: "roster-fleet-tasks",
  PROJECT_REGISTER: "project-register",
  PROJECT_REGISTER_DRIVE: "project-register-drive",
  ESTIMATES: "estimates",
  PROJECTS: "projects",
  PROJECTS_DRIVE: "projects-drive",
  TASK_CLAIMS: "task-claims",
  TASK_CLAIMS_DRIVE: "task-claims-drive",
  WASTE_REQUESTS: "waste-request",
  WASTE_REQUESTS_NOTE: "waste-request-note",
  ESTIMATES_VARIATIONS: "estimates-variations",
  WORKFORCE_ADMIN: "workforce-admin",
  WORKFORCE_MANAGER: "workforce-manager",
  EMPLOYEE_OPTIONS: "employee-options",
  WORKFORCE_EMPLOYEE: "workforce-employee",
  RESOURCE_ACCESS: "resource-access",
  WORKFORCE_SUBCONTRACTOR: "workforce-subcontractor",
  WORKFORCE_SETTING: "workforce-setting",
  CLIENTS_CUSTOMER: "clients-customer",
  CLIENTS_PROSPECT: "clients-prospect",
  CLIENTS_CUSTOMER_USER: "clients-customer-user",
  CUSTOMER_PORTAL_ACCESS_REVOKED: "customer-portal-access-revoked",
  CUSTOMER_PORTAL_INVOICE: "customer-portal-invoice",
  CLIENTS_PROSPECT_USER: "clients-prospect-user",
  INVOICE_DOCKET: "invoice-docket",
  INVOICE_XERO: "invoice-xero",
  INVOICE_CONTRACT: "invoice-contract",
  INVOICE_XERO_BILL: "invoice-xero-bill",
  INVOICE_XERO_CONTACT: "invoice-xero-contact",
  WASTE_MANAGEMENT_SUMMARY: "waste-management-summary",
  WASTE_MANAGEMENT_WEIGH_SCALE: "waste-management-weigh-scale",
  WASTE_MANAGEMENT_WEIGH_BRIDGE: "waste-management-weigh-bridge",
  // WASTE_MANAGEMENT_WEIGH_REPORTS: 'waste-management-weigh-reports',
  WASTE_MANAGEMENT_VEHICLES: "waste-management-vehicles",
  WASTE_MANAGEMENT_LOAD_TYPE: "waste-management-load-type",
  WASTE_MANAGEMENT_WASTE_TYPE: "waste-management-waste-type",
  WASTE_MANAGEMENT_DAILY_REPORTS: "waste-management-daily-reports",
  WASTE_MANAGEMENT_TIPPING_YARD: "waste-management-tipping-yard",
  WASTE_MANAGEMENT_SETTINGS_DOCUMENT: "waste-management-settings-document",
  WASTE_MANAGEMENT_SETTINGS_FORMAT: "waste-management-settings-format",
  REPORTS_DAILY_REPORT: "reports-daily-report",
  REPORTS_WORK_DOCKET: "reports-work-docket",
  REPORTS_TIPPING_REPORT: "reports-tipping-report",
  TIME_TRACKING_SUMMARY: "time-tracking-summary",
  TIME_TRACKING_EMPLOYEE: "time-tracking-employee",
  TIME_TRACKING_SUBCONTRACTOR: "time-tracking-subcontractor",
  TIME_TRACKING_SETTINGS: "time-tracking-settings",
  TIME_TRACKING_HOLIDAYS: "time-tracking-holidays",
  TIME_TRACKING_SHIFTS: "time-tracking-shifts",
  TIME_TRACKING_BREAKS: "time-tracking-breaks",
  TIMESHEET_PAYROLL: "timesheet-payroll",
  PAYROLL_PART1: "payroll-part1",
  PAYROLL_PART2: "payroll-part2",
  ITEM: "item",
  XERO_ITEM: "xero-item",
  ITEM_DOCKET: "item:DOCKET",
  ITEM_ESTIMATION: "item:ESTIMATION",
  ITEM_RATE: "item-rate",
  ITEM_GROUP: "item-group",
  FLEET_REGISTER: "fleet-register",
  INTELLIFLOW_EXTRACTED: "intelliflow-extracted",
  INTELLIFLOW_UPLOADED: "intelliflow-uploaded",
  INTELLIFLOW_EXISTS: "intelliflow-exists",
  WAREHOUSE_BASE: "warehouse-base",
  WAREHOUSE_ITEMS: "warehouse-items",
  WAREHOUSE_PROJECTS: "warehouse-projects",
  WAREHOUSE_HISTORY: "warehouse-history",
  SUPPORT_TEAM: "support-team",
  SUPPORT_TICKET: "support-ticket",
  SUPPORT_DOCUMENT: "support-document",
  SUPPORT_COMMENT: "support-comment",
  CALENDAR: "calendar",
  MESSAGE: "message",
  CHAT_GROUP: "chat-group",
  INTELLIFLOW_STATUS_UPDATE: "intelliflow:status:update",
  SYNC_SOCKET_KEY_XERO: "xero-sync-status",
  MAINTENANCE_WINDOW: "maintenance-window",
} as const;

export const SOCKET_EVENT = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  ACCESS_UPDATE: "access-update",
};

export type SocketEventType = (typeof SOCKET_EVENT)[keyof typeof SOCKET_EVENT];

export enum ROSTER_FLEET_IDENTIFIER {
  UNALLOCATED = "unallocated",
  ALLOCATED = "allocated",
  BOTH = "all",
}
